export default {
    attempted: 'Attempted | Attempted',
    needs_attention: 'Needs attention',
    pending: 'Pending',
    reached: 'Reached',
};
